<template>
    <div class="page-footer">
        版权所有©{{ year }} {{ $utils.copyright.companyName }}.All right reserved.<a class="color-info" href="https://beian.miit.gov.cn/" target="_blank">{{ $utils.copyright.icp }}</a>
    </div>
</template>
<script>
export default {
    name:"pageFooter",
    data(){
        return {
            year: new Date().getFullYear()
        };
    }
}
</script>

<style lang="scss" scoped>
.page-footer{
    // background: #3d3d3d;
    padding: 10px 20px;
    color: $--color-font-gray;
    font-size: 12px;
    text-align: center;
}
</style>